import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export const homeFor = (role) => (role === "admin" ? "/admin" : role === "agent" ? "/agente" : role === "b2b" ? "/listino" : "/account");

export default function ProtectedRoute({ children, role, roles }) {
  const { user } = useAuth();
  const { pathname } = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center paper-grain" data-testid="auth-loading">
        <Loader2 className="w-8 h-8 animate-spin text-[#0F4C81]" />
      </div>
    );
  }
  if (!user) return <Navigate to={`/accedi?next=${encodeURIComponent(pathname)}`} replace />;
  const allowed = roles || (role ? [role] : null);
  if (allowed && !allowed.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  return children;
}
